import { useCallback, useEffect, useRef } from 'react';
import { pxToRem } from 'modules/spacing';
export const useAutoHeight = (options) => {
    const { textAreaRef, textAreaValue, minHeight, maxHeight, enabled = false } = options;
    const previousTextAreaValue = useRef(textAreaValue);
    const setAutoHeight = useCallback(() => {
        if (!enabled) {
            return;
        }
        if (textAreaRef.current) {
            textAreaRef.current.style.minHeight = pxToRem(minHeight); // reset height, otherwise it wont shrink when deleting content
            textAreaRef.current.style.minHeight = pxToRem(textAreaRef.current.scrollHeight);
            if (maxHeight && textAreaRef.current.scrollHeight > maxHeight) {
                textAreaRef.current.style.minHeight = pxToRem(maxHeight); // reset height, otherwise it wont shrink when deleting content
            }
        }
    }, [enabled, textAreaRef, minHeight, maxHeight]);
    useEffect(() => {
        if (textAreaValue !== previousTextAreaValue.current) {
            previousTextAreaValue.current = textAreaValue;
            setAutoHeight();
        }
    }, [setAutoHeight, textAreaRef, textAreaValue]);
    useEffect(() => {
        if (enabled) {
            setAutoHeight();
        }
    });
};
